<template>
  <div class="hello">

    <div style="padding-bottom:10px">
      <i class="fas fa-arrow-left" style="border:1px solid #ccc;padding:10px;cursor:pointer" @click="goback"> </i>
    <span style="font-size:24px;font-weight:500"> Order Details</span>
      <span style="float:right;cursor:pointer" @click="printpop">
   <i class="fas fa-print"></i>
   </span>&nbsp;

    </div>
  <b-card id="demo" >
<h4>Order Details# &nbsp;{{docid.orderNumber}}</h4>
      <CCard>
        <CCardBody>
  <div class="row">
    <div class="col">
      <h5>Shipping Address</h5>
            <span>{{docid.address}}</span>

    </div>
    <div class="col">
      <h5>Payment method</h5>
      <span>{{docid.paymentType}}</span>

    </div>
        <div class="col">
      <h5>Order Summary</h5>
      <span>Ordered on&nbsp;{{docid.orderDate}}</span>
      <span><p>Items Subtotal:&nbsp;{{docid.total}}</p></span>

    </div>

  </div>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardBody>
          <div>
                          <p> Order Status:{{ docid.status }} </p>
          </div>
                          <CRow>
                            
                  <CCol lg="10">

                    <CButton
                      variant="outline"
                      color="success"
                      style="margin-right: 5px;"
                      @click="paymentModal = true"
                      
                    >
<i class="fas fa-hand-holding-usd"></i>

                      <br>
                      Payment Recieved
                    </CButton>
                     <CButton
                      variant="outline"
                      color="success"
                      style="margin-right: 5px;"
                      @click="orderAccepted = true"
                    >
<i class="fas fa-thumbs-up"></i>

                      <br>
                      Order Accepted
                    </CButton>
                     <CButton
                      variant="outline"
                      color="success"
                      style="margin-right: 5px;"
                      @click=" pickup = true"
                    >
<i class="fas fa-box"></i>

                      <br>
                       Ready for pickup
                    </CButton>
                     <CButton
                      variant="outline"
                      color="success"
                      style="margin-right: 5px;"
                      @click="ontheway = true"
                    >
<i class="fas fa-shipping-fast"></i>

                      <br>
                     Delivery on the way
                    </CButton>

                    <!-- <CButton
                      variant="outline"
                      color="info"
                      style="margin-right: 5px; width: min-content"
                      @click="shippedModal = true"
                    >
                      <i class="fa fa-truck" aria-hidden="true"></i> Shipped
                    </CButton> -->
                    <CButton
                      variant="outline"
                      color="success"
                      @click="deliverModal = true"
                      style="margin-right: 5px;"
                    >
                      <i class="fa fa-check-circle" aria-hidden="true"></i>
                      <br/>
                      Delivered
                    </CButton>
                     <!-- <CButton
                      variant="outline"
                      color="info"
                      style="margin-right: 5px;"
                      @click="peykModal = true"
                    >
                      <i class="fa fa-truck" aria-hidden="true"></i>
                      <br>
                      <span> peyk Delivery </span>
                    </CButton> -->
                  </CCol>
                   
                  <CCol v-if="peyk_oid">
                    Order Id :
                    {{ peyk_oid }}
                    <br />
                    Delivery Charge : {{ peyk_symbol + " " + peyk_charge }}
                  </CCol>
                </CRow>

        </CCardBody>
      </CCard>
<CCard>
  <CCardBody>
        <h5>Total items:&nbsp;{{ docid.length }}</h5>
<CCard v-for="item in items" :key="item.title">
  <CCardBody>
    <div class="row">
      <div class="col-2">
 <img
                :src="item.imgUrl"
                style="width: 100px; height: 100px;border-radius:10px"
                class="img-thumbnail"
              />

      </div>
            <div class="col-10">
  <p style="font-size: 16px; font-weight: bold">
                  {{ item.title }}
                </p>
                <p style="font-size: 14px">{{symbol+ " "+ item.price }}</p>
                <p style="font-size: 14px">Quantity: {{ item.qty }}</p>
              
      </div>

    </div>
  </CCardBody>
</CCard>
  </CCardBody>
</CCard>
  </b-card>
    <CModal
      title="Are you sure?"
      size="sm"
      :show.sync="paymentModal"
      :centered="true"
    >
      Payment of the order is received?
      <template #footer>
                <CButton @click="save('Payment Recieved')" color="success">Yes</CButton>
        <CButton @click="paymentModal = false" color="danger">No</CButton>
      </template> 
    </CModal>
    <CModal
      title="Are you sure?"
      size="sm"
      :centered="true"
      :show.sync="orderAccepted"
    >
      Is this order is Accepted?
      <template #footer>
                <CButton @click="save('Order Accepted')" color="success">Yes</CButton>
        <CButton @click="orderAccepted = false" color="danger">No</CButton>
      </template> 
    </CModal>
     <CModal
      title="Are you sure?"
      size="sm"
      :centered="true"
      :show.sync="pickup"
    >
      Is this order is ready for pickup?
      <template #footer>
                <CButton @click="save('Dispatched')" color="success">Yes</CButton>
        <CButton @click="pickup = false" color="danger">No</CButton>
      </template> 
    </CModal>
    <CModal
      title="Are you sure?"
      size="sm"
      :centered="true"
      :show.sync="deliverModal"
    >
      Is this order is Delivered?
      <template #footer>
                <CButton @click="save('Delivered')" color="success">Yes</CButton>
        <CButton @click="deliverModal = false" color="danger">No</CButton>
      </template> 
    </CModal>
    <CModal
      title="Are you sure?"
      size="sm"
      :show.sync="ontheway"
      :centered="true"
    >
      Is this Order is on the way to deliver?
      <template #footer>
                <CButton @click="save('Delivery on the way')" color="success">Yes</CButton>
        <CButton @click="ontheway = false" color="danger">No</CButton>
      </template> 
    </CModal>
  </div>
</template>

<script>
import firebase from "firebase";
import axios from "axios";
// import SelectTable from "../tables/SelectTable";
// import moment from 'moment'

export default {
  name: "vieworder",
  data() {
    return {
      shippedModal : false,
      paymentModal : false,
      deliverModal : false,
      orderAccepted:false,
pickup:false,
ontheway:false,
      peykModal : false,
      docid: null,
      key: "",
      selected: null,
      items: [],
      symbol: localStorage.getItem("symbol"),
      peyk_charge: null,
      peyk_oid: null,
      peyk_symbol: null,
      status:[
        {'name':'Order Placed','icon':`<i class="fa fa-check-circle" aria-hidden="true"></i>`},
        {'name':'Payment Received','icon':`<i class="fa fa-check-circle" aria-hidden="true"></i>`},
        {'name':'Order Accepted','icon':`<i class="fa fa-check-circle" aria-hidden="true"></i>`},
        {'name':'Dispatch','icon':`<i class="fa fa-check-circle" aria-hidden="true"></i>`},
        {'name':'Cancelled','icon':`<i class="fa fa-check-circle" aria-hidden="true"></i>`},
],
      form: {
        token: null,
        "card-id": 7679,
        return: false,
        origin: "51.528387, -0.236007",
        sender_address: "nw1",
        sender_street_name: "street name",
        sender_phone: "9894077825",
        sender_name: "sender name",
        sender_house_number: "null",
        destination: "51.505789, -0.224621",
        receiver_address: "null",
        receiver_street_name: "null",
        receiver_desc: "null",
        receiver_name: "null",
        receiver_house_number: "9865420",
        receiver_phone: "5894258745",
        type: "parcel",
      },
    };
  },
  methods: {
    printpop() {
  let printContents, popupWin;
  printContents = document.getElementById('demo').innerHTML;
  popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
  popupWin.document.open();
  popupWin.document.write(`
    <html>
      <head>
        <title>Near U</title>
        <style>
        footer {
font-size: 9px;
color: #f00;
text-align: center;
}

@page {
size: A4;
margin: 11mm 17mm 17mm 17mm;
}

@media print {
footer {
  position: fixed;
  font-size: 150px;
  bottom: 0;
}

.content-block, p {
  page-break-inside: avoid;
}

html, body {
  width: 210mm;
  height: 297mm;
}
}
        </style>
      </head>
  <body onload="window.print();window.close()">${printContents}</body>
    </html>`
  );
  popupWin.document.close();
},

    onChange(event) {
      console.log(event.target.value);
      this.selected = event.target.value;
      console.log(this.selected);
    },
    goback(){
          this.$router.push("/orderList");
    },
    save(status) {
      this.selected = status;
      const db = firebase.firestore();
      let self = this;
      db.collection("orders")
        .doc(this.docid.docid)
        .update({
          status: status,
        })
        .then(() => {
          self.shippedModal = false;
          self.paymentModal = false;
          self.deliverModal = false;
          self.docid.status = status
          });
      this.chatentry();
    },
    peykSave() {
      const db = firebase.firestore();
      let self = this;
      let temp = this.selected;
      this.selected = "Shipped"
      db.collection("orders")
        .doc(this.docid.docid)
        .update({
          peyk_oid: this.peyk_oid,
          peyk_charge:this.peyk_charge,
          peyk_symbol:this.peyk_symbol,
          peyk_token: self.form.token,
          status: "Shipped",
        })
        .then(() => {
          self.docid.status = 'Shipped'
          this.peykModal = false
          });
      this.chatentry();
    },
    chatentry() {
      let timestamp = Math.round(+new Date());
      const db = firebase.firestore();
      const auth = firebase.auth();
      const phone = auth.currentUser.phoneNumber;
      console.log("chatid", this.docid.chatID);
      let ids = this.docid.chatID.split("-");
      let toid = ids[0] == phone ? ids[1] : ids[0];
      let fromid = ids[0] == phone ? ids[0] : ids[1];
      console.log("phone", phone);
      console.log("from", fromid);
      console.log("to", toid);
      db.collection("messages")
        .doc(this.docid.chatID)
        .collection(this.docid.chatID)
        .doc(timestamp.toString())
        .set({
          from: fromid,
          to: toid,
           notification:[toid],
          timestamp: timestamp,
          content: "Order updated",
          orderID: this.docid.docid,
          status: [this.selected],
          orderNumber: this.docid.orderNumber,
          type: 4,
        })
        .then(() => {
          this.myModal = false;
        });
    },
    peyklogin() {
      const formData = new FormData();
      formData.append(
        "client_id",
        "94c68efae03dd1e6e67c084c7503c2c833146b48346df7356e0b10cd6cc00d69"
      );
      formData.append(
        "client_secret",
        "6603477724fb4d522dbb4b8c3f523d4164745b66b48c668ed56af26df8807e07"
      );
      let self = this;
      axios
        .post("https://peyk.uk/api/v1/get-auth-token", formData)
        .then(function (response) {
          let res = response.data.result.token;
          self.form.token = res;
          self.submitorder(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submitorder() {
      let self = this;
      axios
        .post("https://peyk.uk/api/v1/sandbox-create-order", this.form)
        .then(function (response) {
          console.log("response", response.data);
          self.peyk_symbol = response.data.result.currencySign;
          self.peyk_charge = response.data.result.payablAmount;
          self.peyk_oid = response.data.result.order_id;
          self.peykSave();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
    mounted() {
    },
  created: function () {
    this.docid = this.$route.params.data;
    this.items = this.docid.orders;
    if(this.docid.peyk_oid){
      this.peyk_oid = this.docid.peyk_oid;
      this.peyk_charge = this.docid.peyk_charge;
      this.peyk_symbol = this.docid.peyk_symbol;
    }
    this.form = {
      token: null,
      "card-id": 7679,
      return: false,
      origin: "51.528387, -0.236007",
      sender_address: "nw1",
      sender_street_name: "street name",
      sender_phone: "9894077825",
      sender_name: "sender name",
      sender_house_number: "null",
      destination: "51.505789, -0.224621",
      receiver_address: this.docid.address,
      receiver_street_name: "null",
      receiver_desc: "null",
      receiver_name: this.docid.name,
      receiver_house_number: "9865420",
      receiver_phone: this.docid.phone,
      type: "parcel",
    };
    console.log("route", this.$route.params);
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 8px;
}
a {
  color: #42b983;
}
</style>
